import styled from 'styled-components'

export const DeliveryHeaderContainer = styled.div`
  font-size: 20px;
  font-weight: 600;
  padding: 20px 15px;
`

export const HeaderImg = styled.div`
  text-align: center;
  svg{
    width: 200px;
    height: 200px;
  }
`